import React, { Fragment, useEffect, useState } from 'react';
import InsuranceRequest from './InsuranceRequest';
import { numbersOnlyString, heightFromString } from '../../../Helpers/Conversion';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import TobaccoUsage from '../Helpers/TobaccoUsage';
import TimeRequiredIcon from "../../../../icons/timeRequired.svg";
import CarrierRatingIcon from "../../../../icons/carrierRating.svg";
import SecureInformationIcon from "../../../../icons/secureInformation.svg";
import PropTypes from 'prop-types';
import { savedQuoteEmailDrip } from '../Helpers/SavedQuoteEmailDrip';

function Disclaimer() {
  return (<Fragment>
    <p>By clicking Continue, you are providing your signed permission for Covr Financial Technologies to contact you at
      the email and telephone number provided, including via text message and live, automated and pre-recorded telephone
      calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our
      Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time
      by emailing us at <a href="mailto:support@covrtech.com">SUPPORT@COVRTECH.COM.</a></p>
  </Fragment>);
}

export default function Lga(props) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const planFeatures = [
    {
      icon: TimeRequiredIcon,
      text: "Submit your application today with an all digital process"
    },
    {
      icon: CarrierRatingIcon,
      text: "AM Best has rated this carrier as A+"
    },
    {
      icon: SecureInformationIcon,
      text: "End-to-end 256-bit encryption protects you every step of the way"
    },
  ];

  const onLgaSubmit = (email, firstName, lastName, phone, setLoadingFromComponent) => {
    setLoading(true);
    setLoadingFromComponent(true);
    const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

    const gender = props.basicInfo.gender === 'M' ? 'male' : 'female';
    const tobacco = TobaccoUsage(props.basicInfo.tobacco);
    const height = heightFromString(props.basicInfo.height);
    const weight = numbersOnlyString(props.basicInfo.weight);
    const accountName = account.account && account.account.accountName || '';
    const productName = `${props.formData.quoter.product || 'OPTerm'} ${props.formData.quoter.term || props.formData.quoter.termLength}`;
    const accountNameNoSpaces = accountName.replace(/\s+/g, '');

    const queryParams = new URLSearchParams({
      date_of_birth: props.basicInfo.birthdate,
      gender: gender,
      height: height.heightTotalIn,
      weight: weight,
      state: props.basicInfo.state,
      tobacco: tobacco,
      product: props.formData.quoter.selectedQuote.subProductID,
      coverage: props.formData.quoter.coverageAmount,
      utm_source: accountName,
      utm_medium: 'agents',
      quoteid: props.formData.quoter.selectedQuote.quoteID,
    });

    const submissionBody = {
      "firstName": firstName,
      "lastName": lastName,
      "dob": props.basicInfo.birthdate,
      "gender": gender,
      "state": props.basicInfo.state,
      "zipcode": "00000",
      "insuranceAmount": props.formData.quoter.coverageAmount,
      "coveragePeriod": props.formData.quoter.selectedQuote.termLength,
      "insurancePremium": props.formData.quoter.premium,
      "waiveOffPremiumRider": false,
      "primaryPhoneNumber": phone.replace(/\D/g, ''),
      "email": email,
      "product": productName,
      "uwClass": props.formData.quoter.healthClass,
      "tobacco": TobaccoUsage(props.basicInfo.tobacco),
      "caseId": `${accountNameNoSpaces}_${props.formData.quoter.selectedQuote.quoteID}`,
      "trackingId": props.formData.quoter.selectedQuote.quoteID,
    };

    const LGA_TYPE_ID = "";
    props.logQuote(email, firstName, lastName, props.formData.quoter, LGA_TYPE_ID, queryParams.get("quoteid")).then(() => {
      const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
      fetch(`${covrServicesUrl}/api/LGA/LGAHandoffSubmit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'SessionId': account.sessionId
        },
        body: JSON.stringify(submissionBody),
      })
        .then(res => res.json())
        .then(json => {
          setLoading(false);
          setLoadingFromComponent(false);
          if (json.success && json.data.loginUrl) {
            savedQuoteEmailDrip(submissionBody.email);
            window.location = json.data.loginUrl;
          }
        });
    });
  };

  return <Fragment>
    <InsuranceRequest
      quoterFormState={props.formData.quoter}
      disclaimer={<Disclaimer />}
      planFeature={planFeatures}
      enablePhone={true}
      onBack={props.onBack}
      onSubmit={onLgaSubmit}
      isLoading={loading}
      showCustomizeTermModal={props.showCustomizeTermModal}
      basicInfo={props.basicInfo} />
  </Fragment>;
}

Lga.propTypes = {
  formData: PropTypes.object,
  quoter: PropTypes.object,
  basicInfo: PropTypes.object,
  logQuote: PropTypes.func,
  onBack: PropTypes.func,
  showCustomizeTermModal: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/InsuranceRequest/Lga.js